import type { BoundaryFillConfig } from '~/sidebar/sidebarApps/mapTools/boundary/extraFills/extraFills.types';
import type { BoundaryTerritoryGroupDetails } from '~/store/boundaryTerritoryDetails/boundaryTerritoryGroups.state';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export enum BoundaryTerritoryType {
  Groups = 'groups',
  Numeric = 'numeric',
  Density = 'density',
  Demographic = 'demographic',
  Manual = 'manual'
}

export type CalculateBucketFunctionNumeric = 'min' | 'avg' | 'max' | 'sum';
export type CalculateBucketFunction = CalculateBucketFunctionNumeric | 'equal' | 'sum';

export const isBoundaryTerritoryTypeAllowedWithoutGeocoding = (type: BoundaryTerritoryType) => {
  switch (type) {
    case BoundaryTerritoryType.Manual:
    case BoundaryTerritoryType.Demographic:
      return true;

    default:
      return false;
  }
};

export type BTGWithActiveExtraFill = {
  readonly boundaryTerritoryGroup: BoundaryTerritoryGroup;
  readonly activeFillConfig?: BoundaryFillConfig;
  readonly activeFillInfo?: {
    readonly filterHash?: string;
    readonly btgDetails?: BoundaryTerritoryGroupDetails | null;
  };
};
